/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { SnippetPreviewCandidate } from './snippetPreviewCandidate';

export interface SnippetPreviewCardResult {
  candidate: SnippetPreviewCandidate;
  rendered_html?: string | null;
  rendered_text?: string | null;
  error?: string | null;
}
